import React, { Fragment, useEffect, useState } from "react";
import { socket } from "../../common/cores/socket";
import SportsRight from "../../components/sports/SportsRight";
import connect from "react-redux/lib/connect/connect";
import { ClearBetStore } from "../../common/actions/betAction";
import { ClearSportsList } from "../../common/actions/sportsAction";
import { SetPageInfo } from "../../common/actions/pageAction";
import SportsCenter from "../../components/sports/SportsCenter";
import { ResizeSportsLiveIframe } from "../../common/cores";
import TitleBox from "../../components/common/TitleBox";
import LeftBar from "../../components/sports/sportscomponent/LeftBar";

const SportsLive = props => {
  const [showLeft, setShowLeft] = useState(false);

  // props.ClearBetStore();
  // props.ClearSportsList();
  // useEffect(() => {
  //     // props.ClearBetStore();
  //     // props.ClearSportsList();
  //     socket.emit('room', roomObj);
  //     ResizeSportsLiveIframe();
  //     props.SetPageInfo(roomObj);
  // }, []);

  const roomObj = {
    RoomType: "sport",
    pageType: "toto",
    sportType: "sport",
    gameType: "live",
    sportId: "all",
    esportType: "all"
  };

  props.SetPageInfo(roomObj);
  const roomData = {
    MessageType: "RoomType",
    data: roomObj
  };
  if(window.ws.readyState === 1)
    window.ws.send(JSON.stringify(roomData));
  ResizeSportsLiveIframe();

  const onSetShowLeft = () => {
    setShowLeft(!showLeft);
  };

  return (
    <Fragment>
      <TitleBox title="스포츠 라이브" />
      <div className="contents_wrap">
        <div className="contents_box">
          <LeftBar onSetShowLeft={onSetShowLeft} type="live" title="스포츠 라이브" history={props.history} roomObj={roomObj} />
          <SportsCenter
            roomObj={roomObj}
            type="live"
            onSetShowLeft={onSetShowLeft}
          />
          <SportsRight type="live" />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({});

export default connect(
  mapStateToProps,
  {
    ClearSportsList,
    ClearBetStore,
    SetPageInfo
  }
)(SportsLive);



// WEBPACK FOOTER //
// ./src/containers/Sports/SportsLive.js